
  import { defineComponent, markRaw, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import {
    TPortalVisitsCountByUsersTableItem,
    TPortalVisitsCountTableItem,
    TStatisticsPortalFilter,
  } from '../../../types/statistics/statistics-portal';
  import StatisticsBaseSwitchTab from '../StatisticsBaseSwitchTab.vue';
  import StatisticsPortalVisitsCountNameCell from './StatisticsPortalVisitsCountNameCell.vue';

  export default defineComponent({
    name: 'StatisticsPortalVisitsCountByUsers',
    components: {
      TableTree,
      StatisticsBaseSwitchTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      groupsTableConfig: TTableTreeConfig<TPortalVisitsCountTableItem>;
      usersTableConfig: TTableTreeConfig<TPortalVisitsCountByUsersTableItem>;
      firstTitle: string;
      secondTitle: string;
    } {
      return {
        firstTitle: 'По группам',
        secondTitle: 'По пользователям',
        groupsTableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Пользователи (Активность)',
              renderComponent: {
                component: markRaw(StatisticsPortalVisitsCountNameCell),
                props: (item) => ({
                  value: item.name,
                }),
              },
            },
            {
              field: 'visitsCount',
              title: 'Количество посещений',
              textAlign: 'right',
              width: 210,
              sortable: true,
            },
          ],
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByGroupsTable,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setVisitsCountByGroupsTable,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getVisitsCountByGroupsTable,
          },
        },
        usersTableConfig: {
          columns: [
            {
              field: 'fullName',
              title: 'ФИО пользователя',
            },
            {
              field: 'visitsCount',
              title: 'Количество посещений',
              textAlign: 'right',
              width: 206,
              sortable: true,
            },
          ],
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getVisitsCountByUsersTable,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setVisitsCountByUsersTable,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getVisitsCountByUsersTable,
          },
        },
      };
    },
  });
